import './_polyfills.js'
import './_flickity.js'
import './_slider.js'
import './_card-slider.js'
import './_sub-nav.js'
import './_scroll-spy.js'
import './_scroll-to.js'
import './_toggle.js'
import './_tabbed.js'
import './_date-picker.js'
// import './_listbox.js'
import './_top-bar.js'
import './_validate.js'
import './_form.js'
import './_nav.js'
import './_table.js'
import './_terminal-map.js'
import './_collapsible.js'
import './_flights.js'
import './_filter.js'
import './_search.js'
import './_modal.js'
import './_search-eager.js'
import { createDp } from './_dp.js'
import 'lazysizes/plugins/parent-fit/ls.parent-fit.js'
import 'lazysizes'
import 'flickity-fade'
import 'flickity'
import 'focus-visible'
import './_sticky.js'
import './_parking-limited-availability.js'
import './_parking-widget.js'
import './_parking-widget-v1.js'
import './_fast-track-widget.js'
import './_inject.js'
import './_extras-basket.js'
import './_cart.js'
import './_promo-code.js'
import './_edit-details.js'
import './widget/index.js'
import './_split-partial.js'
import './_dvla.js'
import './_lounge-archive.js'

import * as conditioner from 'conditioner-core'
import { rIC } from 'idlize/idle-callback-polyfills.mjs'

import { h, render } from 'preact'
import SecurityWaitTimes from './components/SecurityWaitTimes'

conditioner.addPlugin({
  moduleSetName: name => `./ui/${name}.js`,
  moduleGetConstructor: module => module.default,
  moduleImport: name => import(/* webpackChunkName: 'conditioner' */ `${name}`),
  monitor: {
    name: 'idle',
    create: () => ({
      matches: false,
      addListener(change) {
        rIC(() => {
          this.matches = true
          change()
        })
      }
    })
  }
})

conditioner.hydrate(document.documentElement)

if (process.env.NODE_ENV !== 'production') {
  import(/* webpackChunkName: "BrowserGrid" */ '@parallaxagency/browsergrid').then(
    ({ BrowserGrid }) => {
      // eslint-disable-next-line no-unused-vars
      const browserGrid = new BrowserGrid([
        {
          width: 1110 + 30,
          cols: 12,
          gutter: 15,
          includeCenterLines: 6
        }
      ])
    }
  )
}

;(async function() {
  let $departureDate = document.querySelector('.js-flight-search-date-from')
  if (!$departureDate) return

  let now = new Date()

  await createDp($departureDate, {
    minDate: now,
    container: $departureDate.parentNode,
    onSelect() {
      let [day, month, year] = this._o.field.value.split('/')
      document.querySelector(
        '.js-flight-search-outbound'
      ).value = `${year}/${month}/${day}`
    }
  })

  let $returnDate = document.querySelector('.js-flight-search-date-to')
  let ret = await createDp($returnDate, {
    minDate: now,
    container: $returnDate.parentNode,
    onSelect() {
      let [day, month, year] = this._o.field.value.split('/')
      document.querySelector(
        '.js-flight-search-inbound'
      ).value = `${year}/${month}/${day}`
    }
  })

  let $radios = Array.from(document.querySelectorAll('.js-flight-search-type'))
  if ($radios[1].checked) {
    ret._o.trigger.disabled = ret._o.field.disabled = false
  }
  $radios.forEach($radio => {
    $radio.addEventListener('change', e => {
      let val = e.target.value
      if (val === 'one-way') {
        ret._o.trigger.disabled = ret._o.field.disabled = true
      } else {
        ret._o.trigger.disabled = ret._o.field.disabled = false
      }
    })
  })
})()

render(<SecurityWaitTimes />, document.getElementById('security-wait-times'))



// WEBPACK FOOTER //
// ./src/js/main.js